import { render, staticRenderFns } from "./depthChartNba.vue?vue&type=template&id=14a82665"
import script from "./depthChartNba.vue?vue&type=script&lang=js"
export * from "./depthChartNba.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports